export default "__VITE_ASSET__B7TSr76i__"